import activities from '@/api/activities';
import booking from '@/api/booking';
import meetings from '@/api/meetings';
import workSchedule from '@/api/workSchedule';

export default {
  activities,
  booking,
  meetings,
  workSchedule,
};
